import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import LoginPage from "@/views/LoginPage.vue";
import NotFoundPage from "@/views/NotFoundPage.vue";
import HomePage from "@/views/HomePage.vue";
import MainLayout from "@/layout/MainLayout.vue";

const routes = [
    {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
        meta: { title: "Iniciar Sesión" },
    },
    {
        path: "/",
        name: "MainLayout",
        component: MainLayout,
        children: [
            {
                path: "/",
                name: "HomePage",
                component: HomePage,
                meta: {requiresAuth: true, title: "Inicio" },
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFoundPage",
        component: NotFoundPage,
        meta: { title: "Página no encontrada" },
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    if (to.meta.requiresAuth && !authStore.access_token) {
        next({ name: "LoginPage" });
    } else if (to.meta.requiresAuth && authStore.access_token) {
        next();
    } else {
        next();
    }
});

export default router;